import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {PopoverSelectDepartmentPage} from './popover-select-department';
import {TranslateModule} from "@ngx-translate/core";
import {InfiniteScrollModule} from "ngx-infinite-scroll";

@NgModule({
  declarations: [
    PopoverSelectDepartmentPage,
  ],
  imports: [
    InfiniteScrollModule,
    IonicPageModule.forChild(PopoverSelectDepartmentPage),
    TranslateModule.forChild()
  ],
})
export class PopoverSelectDepartmentPageModule {}



// WEBPACK FOOTER //
// ./src/pages/popover-select-department/popover-select-department.module.ts